// ============================================================================
// Canonical host. Must be main.js's FIRST import.
//
// www.dwsquad.com serves this site too (Cloudflare proxies it straight to the
// same Pages project — no redirect at the edge), but the app's auth flow is
// origin-sensitive twice over: Supabase only trusts allow-listed redirect
// origins, and the PKCE verifier lives in the localStorage of whichever origin
// requested the link. Letting people use the app on www mints sign-in links
// that dead-end or loop. Hop to the apex before lib/supabase.js can even
// initialize (module order in main.js guarantees that).
//
// NOT an inline <script> in index.html: the CSP in public/_headers is
// script-src 'self' with no inline allowance, so an inline hop never runs in
// production. From the bundle it is 'self' and always runs.
//
// pages.dev preview deploys are deliberately left alone — a preview must work
// as itself, not bounce to production.
// ============================================================================

if (window.location.hostname === 'www.dwsquad.com') {
  window.location.replace(
    'https://dwsquad.com' +
    window.location.pathname + window.location.search + window.location.hash
  );
}
